export const averageRating = (reviews) =>
  reviews.reduce((total, next) => total + next.rating, 0) / reviews.length;
